// extracted by mini-css-extract-plugin
export var animationContainer = "_j8-0";
export var footer = "_j8-1";
export var gray = "_j8-2";
export var lineItem = "_j8-3";
export var lineItemImage = "_j8-4";
export var lineItemInfo = "_j8-5";
export var lineItemText = "_j8-6";
export var lineItems = "_j8-7";
export var modalContent = "_j8-8";
export var options = "_j8-9";
export var orderName = "_j8-a";
export var refundAmount = "_j8-b";